function ready() {
    initSearchYearFirst();
}

document.addEventListener("DOMContentLoaded", ready);

function getMakeModelYearFromCache() {
    return {
        make: window.sessionStorage.getItem("user_make"),
        model: window.sessionStorage.getItem("user_model"),
        year: (window.sessionStorage.getItem("user_year") !== '' ? window.sessionStorage.getItem("user_year") : "0"),
        compat: window.sessionStorage.getItem("user_compat")
    };
}

function initSearchYearFirst() {
    document.getElementsByTagName('body')[0].classList.add('is-year-first');

    document.getElementById('year-input').removeAttribute('disabled');

    document.getElementById('make-input').disabled = 'disabled';
    document.getElementById('model-input').disabled = 'disabled';

    // if (window.sessionStorage.getItem("user_year") != undefined) {
    //     document.querySelector(".vehicle-menu-container").style.display = "none";
    // }

    console.log('initSearchYearFirst');

    // Create DOM reference and event listener for make input
    const makeInput = document.getElementById("make-input");
    makeInput.addEventListener('change', (e) => onMakeChangeV2(e));

    // Create DOM reference and event listener for model input
    const modelInput = document.getElementById("model-input");
    modelInput.addEventListener('change', (e) => onModelChangeV2(e));

    // Create DOM reference and event listener for year input
    const yearInput = document.getElementById("year-input");
    yearInput.addEventListener('change', (e) => onYearChangeV2(e));

    // Create DOM reference for submit "Let's Go" button


    // Setup vehicle menu by creating all make option elements
    function initialize() {
        const {make, model, year, compat} = getMakeModelYearFromCache();
        let query = "";
        if (make && model && year) {
            query = `?make=${make}&model=${model}&year=${year}`;
        }
        console.log(make, model, year, query);

        if (window.scs_use_optgroup) {
            query += (query != '' ? '&' : '?') + `with_sales=yes`;
        }
        const urlYears = "https://scsbiz3.wearevisum.com/api/v1/years" + query;

        fetch(urlYears, {
            mode: "cors", headers: {'Access-Control-Allow-Origin': '*'}
        }).then((res) => res.json()).then((data) => {

            const selectedFound = handleMakesResponseYearFirst(data, make, model, year, makeInput, modelInput, yearInput);

            if (selectedFound.selectedYearFound) {
                yearInput.dispatchEvent(new Event('change'));
            }

        });
    }

    initialize();

    function onMakeChangeV2(e) {
        // JsLoadingOverlay.show({
        //     'containerID': 'model-input-container',
        //     "spinnerIcon": "ball-beat",
        //     "spinnerSize": "1x",
        // });

        // Get the selected make
        const selectedMake = e.target.value;
        makeInput.value = selectedMake;
        // Make sure the user selected a valid make
        if (selectedMake === "")
            return;

        const {make, model, year, compat} = getMakeModelYear();

        let urlModels = `https://scsbiz3.wearevisum.com/api/v1/years?year=${year}&make=${selectedMake}`;
        if (window.scs_use_optgroup) {
            urlModels += `&with_sales=yes`;
        }

        let selectedFound = false;
        // Get the data for the selected make from the database
        fetch(urlModels, {
            mode: "cors", headers: {'Access-Control-Allow-Origin': '*'}
        }).then((res) => res.json()).then((makeData) => {
            const models = makeData.models;
            // Remove all other models from the model input before adding new
            modelInput.innerHTML = "<option value=''>Model</option>";

            Object.keys(models).sort().forEach((model1) => {
                const modelOption = document.createElement("option");
                modelOption.value = model1;
                modelOption.innerHTML = model1;
                let selected = '';
                if (model1 === model) {
                    selectedFound = true;
                    selected = ' selected="selected"';
                }
                modelInput.innerHTML = `${modelInput.innerHTML}<option value="${model1}" ${selected}>${model1}</option>`;

            });
            // Enable model input to be clicked
            modelInput.removeAttribute("disabled");

            //JsLoadingOverlay.hide();

            if (selectedFound) {
                modelInput.dispatchEvent(new Event('change'));
                //modelInputMobile.dispatchEvent(new Event('change'));
            }
        })


    }

    function onModelChangeV2(e) {
        const selectedModel = e.target.value;
        modelInput.value = selectedModel;

        // Make sure the user selected a valid year
        console.debug('onModelChangeV2');
        if (selectedModel === "") {
            console.debug('No error found');
            return;
        }

        // JsLoadingOverlay.show({
        //     'containerID': 'vehicle-submit-button',
        //     "spinnerIcon": "ball-beat",
        //     "spinnerSize": "1x",
        // });

        const {make, model, year, compat} = getMakeModelYear();

        const data = {
            "make": make,
            "model": selectedModel,
            "year": year
        };
        console.debug(data);

        handleCheck(data, function () {
            const {make, model, year, compat} = getMakeModelYearFromCache();
            if (make && model && year) {
                window.location.href = `https://seatcoversolutions.com/products/luxury-seat-covers?make=${make}&model=${model}&year=${year}`;
                if (submitButtonLink)
                    submitButtonLink.setAttribute("href", `https://seatcoversolutions.com/products/luxury-seat-covers?make=${make}&model=${model}&year=${year}`);
                if (submitButton)
                    submitButton.removeAttribute('disabled');
            }
            if (document.getElementById('vehicle-submit-button')) {
                document.getElementById('vehicle-submit-button').style.display = "block";
                // JsLoadingOverlay.hide();
            }
        });


    }

    function onYearChangeV2(e) {
        // JsLoadingOverlay.show({
        //     'containerID': 'make-input-container',
        //     "spinnerIcon": "ball-beat",
        //     "spinnerSize": "1x",
        // });

        const {make, model, year, compat} = getMakeModelYearFromCache();

        const selectedYear = e.target.value;
        yearInput.value = selectedYear;

        // Make sure the user selected a valid year
        if (selectedYear === "") {
            console.debug('No error found');
            return;
        }

        let urlMakes = `https://scsbiz3.wearevisum.com/api/v1/years?year=${selectedYear}`;
        if (window.scs_use_optgroup) {
            urlMakes += `&with_sales=yes`;
        }

        // Get the data for the selected make from the database
        fetch(urlMakes, {
            mode: "cors", headers: {'Access-Control-Allow-Origin': '*'}
        }).then((res) => res.json()).then((yearData) => {
            const makes = yearData.makes;

            let selectedFound = false;
            makeInput.innerHTML = "<option value=''>Make</option>";

            makes.forEach((make1) => {
                let selected = '';
                if (make === make1) {
                    selectedFound = true;
                    selected = ' selected="selected"';
                }
                makeInput.innerHTML = `${makeInput.innerHTML}<option ${selected} value="${make1}">${make1}</option>`;

            });

            // Enable model input to be clicked
            makeInput.removeAttribute("disabled");


            if (selectedFound) {
                makeInput.dispatchEvent(new Event('change'));
            }

            // JsLoadingOverlay.hide();
        });
    }
}

function handleMakesResponseYearFirst(data, make, model, year, makeInput, modelInput, yearInput) {
    let selectedYearFound = false;
    let selectedFound = false;
    let selectedModelFound = false;
    let years = [];
    if (Array.isArray(data)) {
        years = data;
    } else {
        makes = data.makes;
        models = data.models;
        years = data.years;

        /*modelInput.innerHTML = "<option value=''>Model</option>";
        modelInputMobile.innerHTML = "<option value=''>Model</option>";
        Object.keys(models).sort().forEach((model1) => {
            const modelOption = document.createElement("option");
            modelOption.value = model1;
            modelOption.innerHTML = model1;
            let selected = '';
            if (model === model1) {
                selectedModelFound = true;
                selected = ' selected="selected"';
            }
            modelInput.innerHTML = `${modelInput.innerHTML}<option ${selected} value="${model1}">${model1}</option>`;
            modelInputMobile.innerHTML = `${modelInputMobile.innerHTML}<option ${selected} value="${model1}">${model1}</option>`;
        });
        // Enable model input to be clicked
        modelInput.removeAttribute("disabled");
        modelInputMobile.style.display = "block";

        yearInput.innerHTML = "<option value=''>Year</option>";
        yearInputMobile.innerHTML = "<option value=''>Year</option>";
        Object.keys(years).sort().reverse().forEach((year1) => {
            const yearOption = document.createElement("option");
            yearOption.value = year1;
            yearOption.innerHTML = year1;
            let selected = '';
            if (year === year1) {
                selectedYearFound = true;
                selected = ' selected="selected"';
            }
            yearInput.innerHTML = `${yearInput.innerHTML}<option ${selected} value="${year1}">${year1}</option>`;
            yearInputMobile.innerHTML = `${yearInputMobile.innerHTML}<option ${selected} value="${year1}">${year1}</option>`;
        });
        // Enable year input to be clicked
        yearInput.removeAttribute("disabled");
        yearInputMobile.style.display = "block";*/
    }
    // console.log('years:', years, year);
    yearInput.innerHTML = "<option value=''>Year</option>";
    years.forEach((year1) => {
        let selected = '';
        if (year === year1) {
            selectedYearFound = true;
            selected = ' selected="selected"';
        }
        yearInput.innerHTML = `${yearInput.innerHTML}<option ${selected} value="${year1}">${year1}</option>`;

    });
    //yearInput.

    return {selectedFound, selectedYearFound, selectedModelFound};
}

function getMakeModelYear() {
    const makeInput = document.getElementById("make-input");
    const modelInput = document.getElementById("model-input");
    const yearInput = document.getElementById("year-input");



    let compat = window.sessionStorage.getItem("user_compat");

    if (!makeInput) {
        return {};
    }

    let year = yearInput.value;
    let make = makeInput.value;
    let model = modelInput.value;

    year = year.trim();
    make = make.trim();
    model = model.trim();

    // Set the current selected vehicle to the one from the dropdown
    window.sessionStorage.setItem("user_year", year);
    window.sessionStorage.setItem("user_make", make);
    window.sessionStorage.setItem("user_model", model);

    return {make, model, year: (year !== '' ? year : "0"), compat};
}





var checkCache = {};

function handleCheck(data, callback) {
    if (data.year === '' || data.make === '' || data.model === '') {
        return;
    }

    if (typeof _learnq !== 'undefined' && window.location.href.indexOf('/products/') !== -1) {
        setTimeout(function () {
            const images = document.querySelector('.product-images__slide.is-selected img');
            let image = null
            if (images) {
                const srcset = images.srcset.split(',');
                const parts = srcset[srcset.length - 1].split(' ')
                image = parts[0]
            }
            const URL = window.location.href
            const urlParts = URL.split("variant=")
            const variant_id = document.querySelector('.form [name="id"]')?.value;
            const image1 = document.querySelector('img[alt$=" - ' + data.colorCode + '"]')?.src
            const reg = /_[0-9x]+_[^.]+\./
            const image2 = image1?.replace(reg, ".");

            const dd = {
                ...data,
                colorCode: document.querySelector('[name="Color"]:checked') ? document.querySelector('[name="Color"]:checked').value : '',
                vehicle: `${data.year} ${data.make} ${data.model}`,
                variant_id: variant_id,
                id: document.querySelector('[name="product-id"]') ? document.querySelector('[name="product-id"]').value : '',
                title: document.querySelector('h1.product-title') ? document.querySelector('h1.product-title').innerText : '',
                price: document.querySelector('[name="Seats"]:checked + label span span') ? document.querySelector('[name="Seats"]:checked + label span span').innerText : '',
                image: image ? 'https:' + image : (image2 ? image2 : ''),
                URL: urlParts && urlParts[0] && (urlParts[0].trim().replace('?', '') + '?variant=' + variant_id),
            };

            console.log(dd);

            _learnq.push(['track', 'Viewed Variant', dd]);
        }, 650)
    }

    /*if (typeof checkCache[JSON.stringify(data)] !== 'undefined') {
        const resp = checkCache[JSON.stringify(data)];

        setAvailability(resp);
        window.sessionStorage.setItem("user_compat", resp.data.compatibility);
        window.sessionStorage.setItem("variant_availability", JSON.stringify(resp.data.compatibility));
        if (callback) callback(resp.data.compatibility);
    } else*/
    {
        fetch("https://scsbiz3.wearevisum.com/api/v1/check", {
            method: "POST",
            mode: "cors",
            headers: {'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json'},
            body: JSON.stringify(data)
        }).then((res) => res.json()).then((resp) => {
            checkCache[JSON.stringify(data)] = resp;
            console.log(resp);

            document.querySelectorAll('[name="Seats"]').forEach(function (el) {
                //el.classList.add('is-disabled');
                //el.setAttribute('disabled', 'disabled');
            })
            document.querySelectorAll('[name="Color"]').forEach(function (el) {
                //el.classList.add('is-disabled');
                //el.setAttribute('disabled', 'disabled');
            })

            setAvailability(resp);
            window.sessionStorage.setItem("user_compat", resp.data.compatibility);
            window.sessionStorage.setItem("variant_availability", JSON.stringify(resp.data.compatibility));
            if (callback) callback(resp.data.compatibility);
        });
    }
}
var availability = {};

function setAvailability(resp) {
    availability = resp.data.availability;

    const submitButton = document.getElementById("vehicle-submit-button");
    const submitButtonLink = document.querySelector(".vehicle-button button");
    const addToCartButton = document.querySelector('#AddToCart');

    const typeInput = document.querySelector('[name="Seats"]:checked');

    if (resp.data.compatibility !== 'Y' && resp.data.alert && resp.data.alert !== '') {
        // set alert for compatibility
        const vehicleSuitableText = document.getElementById('vehicle-suitable-text');
        let vehicleSuitableTextAlert = document.getElementById('vehicle-suitable-text-alert');
        if (!vehicleSuitableTextAlert) {

            vehicleSuitableTextAlert = document.createElement("div");
            vehicleSuitableTextAlert.id = 'vehicle-suitable-text-alert';
            vehicleSuitableTextAlert.innerHTML = resp.data.alert;
            if (vehicleSuitableText) {
                if (vehicleSuitableText.nextSibling) {
                    vehicleSuitableText.parentNode.insertBefore(vehicleSuitableTextAlert, vehicleSuitableText.nextSibling);
                } else {
                    vehicleSuitableText.parentNode.appendChild(vehicleSuitableTextAlert);
                }
            }
        } else {
            vehicleSuitableTextAlert.innerHTML = resp.data.alert;
        }
        vehicleSuitableTextAlert.style.display = 'block';
    } else {
        const vehicleSuitableTextAlert = document.getElementById('vehicle-suitable-text-alert');
        if (vehicleSuitableTextAlert) {
            vehicleSuitableTextAlert.innerHTML = '';
            vehicleSuitableTextAlert.style.display = 'none';
        }
    }

    const img1 = document.querySelector('.vehicle-menu-selected-container img');
    if (img1) {
        if (resp.data.compatibility !== 'Y') {
            img1.style.display = 'none';
        } else {
            img1.style.display = 'inline';
        }
    }


    if (submitButton
        && resp.data.compatibility === 'Y'
        && window.getComputedStyle(document.querySelector(".vehicle-button")).display !== 'none') {
        submitButton.removeAttribute('disabled');
        if (submitButtonLink) {
            const {make, model, year, compat} = getMakeModelYear();
            if (make && model && year) {
                submitButtonLink.setAttribute("href", `https://seatcoversolutions.com/products/luxury-seat-covers?make=${make}&model=${model}&year=${year}`);
                // submitButtonLink.addEventListener('click', () => {
                //     onButtonClick();
                // });
                // submitButton.addEventListener('click', () => {
                //     onButtonClick();
                // });
            }
        }

    }

    const type = typeInput ? typeInput.value : '';

    if (availability && type !== '' && typeof availability[type] !== 'undefined') {
        const colors = availability[type];
        console.log('colors: ');
        console.log(colors);

        let foundColor = false;
        for (let color in colors) {
            console.log(color);
            const color_trans = color.replaceAll('&', '').replaceAll(' ', '');
            const colorButton = document.querySelector('[name="Color"][value="' + color + '"]');
            if (!colorButton) continue;
            const parentElem = colorButton.closest('.color-input-custom');
            console.log('parentElem:');
            console.log(parentElem);
            if (colors[color]) {
                foundColor = true;
                console.log('found:' + color);
                colorButton.removeAttribute('disabled');
                colorButton.classList.remove("is-disabled");

                parentElem.classList.remove('is-disabled');
                console.log(parentElem);
            } else {
                colorButton.setAttribute('disabled', 'disabled');
                colorButton.classList.add("is-disabled");
                parentElem.classList.add('is-disabled');
                console.log('did not find:' + color);
            }
        }
        const typeInput = document.querySelector('[name="Seats"][value="' + type + '"]');
        console.debug(typeInput);
        if (foundColor) {
            if (typeInput) {
                typeInput.classList.remove("is-disabled");
                typeInput.removeAttribute('disabled');
            }

            if (addToCartButton) {
                addToCartButton.style.display = "block";
                addToCartButton.removeAttribute('disabled');
            }
            if (submitButtonLink) {
                const {make, model, year, compat} = getMakeModelYear();
                submitButtonLink.setAttribute("href", `https://seatcoversolutions.com/products/luxury-seat-covers?make=${make}&model=${model}&year=${year}`);
            }
            if (submitButton) {
                submitButton.removeAttribute("disabled");
                submitButton.style.display = "block";
            }
        } else {
            if (typeInput) {
                typeInput.classList.add("is-disabled");
                typeInput.setAttribute('disabled', 'disabled');
            }
            if (addToCartButton) {
                addToCartButton.setAttribute('disabled', 'disabled');
            }
        }
    } else if (availability) {
        const types = document.querySelectorAll('[name="Seats"]:not(:checked)');
        for (let type1 of types) {
            const typeValue = type1.value;
            const colors = availability[typeValue];
            console.log('colors: ');
            console.log(colors);
            let foundColor = false;
            for (let color in colors) {
                console.log(color);
                const colorButton = document.querySelector('[name="Color"][value="' + color + '"]');
                if (!colorButton) continue;
                const color_trans = color.replaceAll('&', '').replaceAll(' ', '');
                const parentElem = colorButton.closest('.color-input-custom');
                //parentElem.classList.add('is-disabled');
                if (colors[color]) {
                    foundColor = true;
                    parentElem.classList.remove('is-disabled');
                    colorButton.removeAttribute('disabled');
                    colorButton.classList.remove("is-disabled");
                } else {
                    parentElem.classList.add('is-disabled');
                    colorButton.setAttribute('disabled', 'disabled');
                    colorButton.classList.add("is-disabled");
                }
            }
            const typeInput = document.querySelector('[name="Seats"][value="' + typeValue + '"]');
            console.debug(typeInput);
            if (foundColor) {
                if (typeInput) {
                    console.log(`Making ${typeValue} enabled`);
                    typeInput.classList.remove("is-disabled");
                    typeInput.removeAttribute('disabled');

                }
                if (submitButton) {
                    submitButton.removeAttribute('disabled');
                }
            } else {
                if (typeInput) {
                    console.log(`Making ${typeValue} disabled`);
                    typeInput.classList.add("is-disabled");
                    typeInput.setAttribute('disabled', 'disabled');
                }
            }
        }
    }
    if (document.querySelector('.color-input-custom.selected.is-disabled')
        && document.querySelector('.color-input-custom:not(.is-disabled)'))
        document.querySelector('.color-input-custom:not(.is-disabled)').click()

}